export class VueHelpers{
    constructor() {
        this.updateQueryString = function (name, value, remove = false) {
            if ('URLSearchParams' in window) {
                var searchParams = new URLSearchParams(window.location.search);
                if (!remove) {
                    searchParams.set(name, value);

                } else {
                    searchParams.delete(name);
                }
                const updatedUrl = window.location.protocol + "//" + window.location.host + window.location.pathname + '?' + searchParams.toString();
                window.history.pushState({ path: updatedUrl }, '', updatedUrl);
            }
        };

        this.clearQueryString =  function () {
            if(window.location.search != "") {
                const updatedUrl = window.location.protocol + "//" + window.location.host + window.location.pathname;
                window.history.pushState({ path: updatedUrl }, '', updatedUrl);
            }
        };

        this.scrollToTopOfFlow = function() {
            const component = document.querySelector('.p-sidebar-content');
            let componentTop = document.querySelector('.p-sidebar-header').offsetTop;
            component.scrollTop = componentTop;
        };

        this.getTimeDifferenceInSeconds = function(timestamp) {
            return Math.round(Date.now() / 1000) - Math.round(timestamp);
        };

        this.getTimestampInSeconds = function(){
            return Math.round(Date.now() / 1000);
        }

        this.getAntiForgeryToken = function(){
            return document.getElementById('RequestVerificationToken').value;
        }

        this.flowNameQueryKey = "flowName";
        this.flowStepQueryKey = "flowStep";
        this.passwordResetQueryKey = "pwreset";
        this.passwordResetIdQueryKey = "id";
        this.passwordResetTokenQueryKey = "tkn";

        this.createModeKey = "create";
        this.updateModeKey = "update";
        this.accountTypeKey = "account";
        this.profileTypeKey = "profile";

        this.bmmkArtistKey = "bmmkArtist";
        this.ummkArtistKey = "ummkArtist";
        this.ummkYoungKey = "ummkYoung";
    }
};
export default new VueHelpers();